<template>
  <!-- 选择日期、星期 -->
  <div class="running-time-and-date">
    <el-radio-group v-model="showWeekOrDateSelect"
                    size="mini">
      <el-radio :label="0">按星期营业</el-radio>
      <el-radio :label="1">按日期营业</el-radio>
    </el-radio-group>
    <!-- 选择星期 -->
    <div v-if="showWeekOrDateSelect == 0"
         class="week-checked-area">
      <!-- 全选 -->
      <el-checkbox border
                   size="mini"
                   :indeterminate="isIndeterminate"
                   v-model="checkAllDate"
                   @change="handleCheckAllChange">全选</el-checkbox>
      <!-- 星期 -->
      <div style="margin: 15px 0"></div>
      <el-checkbox-group v-model="checked_week_list"
                         @change="handleCheckedWeekChange"
                         size="mini">
        <el-checkbox-button v-for="(item, id) in weekList"
                            :label="item.id"
                            :key="id">{{ item.name }}</el-checkbox-button>
      </el-checkbox-group>
    </div>
    <!-- 选择日期 -->
    <div v-else
         class="week-checked-area">
      <p style="margin-bottom: 20px">
        开放日期：
        <el-tag style="margin-right: 10px"
                size="mini"
                v-for="item in selectMulityDate"
                :key="item.index">{{ item }}</el-tag>
      </p>
      <el-date-picker size="mini"
                      type="dates"
                      v-model="selectMulityDate"
                      format="yyyy 年 MM 月 dd 日"
                      value-format="yyyy-MM-dd"
                      @change="confirmSelectDate"
                      placeholder="选择一个或多个日期">
      </el-date-picker>
    </div>

    <!-- 添加营业时间段 -->
    <div>
      <p style="margin: 20px 0;font-weight:border">营业时间段：</p>
      <div style="margin-left: 20px">
        <!-- <el-time-picker size="mini"
                        is-range
                        v-model="runningTimePicker"
                        :default-value="new Date(new Date().setHours(9, 0, 0, 0))"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        placeholder="选择开始时间"
                        format="HH:mm"
                        value-format="HH:mm">
        </el-time-picker> -->
        <el-time-picker size="mini"
                        v-model="beginRunningTime"
                        :default-value="new Date(new Date().setHours(9, 0, 0, 0))"
                        range-separator="至"
                        placeholder="选择开始时间"
                        format="HH:mm"
                        value-format="HH:mm">
        </el-time-picker>
        至
        <el-time-picker size="mini"
                        clear-icon
                        v-model="endRunningTime"
                        :default-value="new Date(new Date().setHours(9, 0, 0, 0))"
                        range-separator="至"
                        placeholder="选择结束时间"
                        format="HH:mm"
                        value-format="HH:mm">
        </el-time-picker>
        <!-- <el-input size="mini"
                  placeholder="请输入时间范围"
                  style="width:200px"
                  v-model="runningTimePicker"></el-input> -->
        <el-button @click="addRunningTime"
                   align="center"
                   size="mini"
                   style="margin-left: 20px"
                   v-model="runningTimePicker">添加</el-button>
        <!-- 营业时间的显示 -->
        <div>
          <div class="running-time-list"
               v-for="(time, index) in runningTimeList"
               :key="index">
            <span>营业时段【{{ index + 1 }}】:</span>
            <span style="margin-left: 20px">{{ time[0] }}-{{ time[1] }}</span>
            <!-- 去掉一个营业时间 -->
            <el-link style="float: right"
                     :underline="false"
                     icon="el-icon-circle-close"
                     @click="removeTime(index)"></el-link>
          </div>
        </div>
        <!-- 收尾 -->
      </div>
    </div>

  </div>
</template>

<script>
const week_list = [
  {
    id: 1,
    name: '星期一',
  },
  {
    id: 2,
    name: '星期二',
  },
  {
    id: 3,
    name: '星期三',
  },
  {
    id: 4,
    name: '星期四',
  },
  {
    id: 5,
    name: '星期五',
  },
  {
    id: 6,
    name: '星期六',
  },
  {
    id: 0,
    name: '星期日',
  },
]
export default {
  name: 'select-date-type',
  data() {
    return {
      selectMulityDate: '',
      showWeekOrDateSelect: this.showWeekOrDate,
      runnintTimeInfor: '内容',
      //   时间段
      beginRunningTime: '',
      endRunningTime: '',
      runningTimePicker: '',
      runningTimeList: [],
      //   日期
      //   星期
      checkAllDate: false,
      isIndeterminate: true,
      checked_week_list: [],
      weekList: week_list,
    }
  },
  props: {
    // runTimeList: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   },
    // },
    // runningTimePicker:{},
    showWeekOrDate: {
      type: Number,
      default: 0,
    },
    checkedWeekList: Array,
  },

  watch: {
    checkedWeekList(newVal) {
      this.checked_week_list = newVal
    },
    showWeekOrDate(newVal) {
      this.showWeekOrDateSelect = newVal
    },
    runningTimeList(newValue) {
      this.runningTimeList = newValue
    },
  },
  methods: {
    // 营业星期，全选按钮
    handleCheckAllChange(val) {
      // console.log(val) //是 否  全选，val：选择的id
      let checked = val ? week_list : []
      if (checked.length == 0) {
        this.checked_week_list = []
        this.$emit('selectAllWeek', this.checked_week_list)
      } else {
        checked.forEach((i) => {
          this.checked_week_list.push(i.id)
        })
        this.$emit('selectAllWeek', this.checked_week_list)
      }
      this.isIndeterminate = false
    },
    // 选择星期
    handleCheckedWeekChange(value) {
      //console.log(value.index) //当前选项
      let checkedCount = value.length
      // 判断 是否全选
      this.checkAll = checkedCount === this.weekList.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.weekList.length
      // 发送事件
      this.$emit('handleCheckedWeekChange', this.checked_week_list)
    },
    // 选择营业日期
    confirmSelectDate(val) {
      this.$emit('confirmSelectDate', val)
    },
    // 添加营业时间
    addRunningTime() {
      // 添加一个营业时间
      let timeList = []
      timeList.push(this.beginRunningTime)
      timeList.push(this.endRunningTime)
      // console.log(timeList)
      this.runningTimeList.push(timeList)
      this.$emit('addRunningTime', this.runningTimeList)
    },
    // addRunningTimeOld() {
    //   console.log(this.runningTimePicker)
    //   this.runningTimeList.push(this.runningTimePicker)
    //   this.$emit('addRunningTime', this.runningTimeList)
    // },
    // 减掉营业时间
    removeTime(val) {
      // console.log(val)
      // console.log(this.runningTimeList)
      this.runningTimeList.splice(val, 1)
      this.$emit('removeTime', this.runningTimeList)
    },
    //
    saveTimeInfor() {},
    // 更新营业时间
    changeRunningTime() {},
  },
}
</script>

<style>
.running-time-and-date {
  margin-top: 20px;
}
.week-checked-area {
  padding: 20px;
}
.running-time-list {
  margin-top: 10px;
  background-color: rgb(238, 238, 238);
  padding: 10px;
  width: 52%;
}
</style>